import { EnumNavigationBar, NavigationContext } from '@Contexts/navigation';
import { FC, PropsWithChildren, useState } from 'react';

export const NavigationProvider: FC<PropsWithChildren> = ({ children }) => {
    const [navigationBar, setNavigationBar] = useState(EnumNavigationBar.Main);

    return (
        <NavigationContext.Provider value={{ navigationBar, setNavigationBar }}>{children}</NavigationContext.Provider>
    );
};
